/**
 * The literal workstream_key "program-level" means "belongs to no
 * workstream" (proto doc comment on DeliverableImportProposal.workstream_key)
 * — never a fictional workstream name, but also not fit to show verbatim to
 * a reviewer.
 */ export const PROGRAM_LEVEL_KEY = 'program-level';
const PROGRAM_LEVEL_LABEL = 'Program-level';
export function workstreamLabel(ws) {
    return ws.key === PROGRAM_LEVEL_KEY ? PROGRAM_LEVEL_LABEL : ws.label;
}
/**
 * One-line status for a workstream in the NEXT_WORKSTREAM picker, e.g.
 * "12 of 12 reviewed · committed", "not started", "6 of 18 reviewed".
 */ export function workstreamStatus(ws) {
    if (ws.totalToReview === 0 || ws.reviewed === 0) return 'not started';
    const base = `${ws.reviewed} of ${ws.totalToReview} reviewed`;
    const committedTarget = ws.approved + ws.editedApproved;
    if (committedTarget > 0 && ws.committed >= committedTarget) return `${base} · committed`;
    return base;
}
